import React from "react";
import { useNavigate } from 'react-router-dom';
import "./Policies.css";

const TermsAndConditions: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="policy-container">
      <button className="back-button" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <h1>Terms and Conditions</h1>
      <p className="policy-intro">Last Updated: January 5, 2025</p>

      <p className="paragraph">
        Welcome to Fervoir. These policies outline our Terms of Service, Privacy Practices, Content Guidelines, Safety Measures, Security Protocols, Consent Policies, and Customer Service Commitments. By using Fervoir, you agree to these terms. If you do not agree, please do not use our platform.
      </p>

      <section className="terms-section">
        <h2 className="section-title">Terms & Conditions</h2>

        <div className="content-block">
          <h3 className="sub-title">Acceptance of Terms</h3>
          <p className="text">
            By downloading, accessing, or using Fervoir, you agree to be bound by these Terms & Conditions and our Privacy Policy.
            These Terms apply to all users and visitors. We reserve the right to modify or update these Terms at any time in
            accordance with platform guidelines. Continued use of Fervoir after changes constitutes your acceptance of the revised Terms.
          </p>
        </div>

        <div className="content-block">
          <h3 className="sub-title">Eligibility</h3>
          <ul className="list">
            <li>You must be at least 18 years of age to use Fervoir.</li>
            <li>You must not be prohibited from using digital dating services under any applicable laws or legal restrictions.</li>
            <li>You must provide accurate and up-to-date information during registration and must not impersonate any individual or entity.</li>
            <li>You are not permitted to use Fervoir if you are registered as a sex offender or have been convicted of a related crime.</li>
            <li>Use of the app in jurisdictions where dating services are illegal is strictly prohibited.</li>
          </ul>
        </div>

        <div className="content-block">
          <h3 className="sub-title">Account Registration & Security</h3>
          <ul className="list">
            <li>You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account.</li>
            <li>You agree not to share your account or login information with others or allow unauthorized access.</li>
            <li>If you suspect any unauthorized use of your account, please notify us immediately at <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>.</li>
            <li>We reserve the right to suspend or terminate accounts that violate these Terms or pose a security or legal risk to our community.</li>
          </ul>
        </div>

        <div className="content-block">
          <h3 className="sub-title">Prohibited Activities</h3>
          <p>You must not engage in the following:</p>
          <ul className="list">
            <li>Harassment, stalking, exploitation, or abuse of any kind.</li>
            <li>Creating fake profiles, impersonation, or using misleading information.</li>
            <li>Uploading or sharing sexually explicit, violent, hateful, illegal, or misleading content.</li>
            <li>Engaging in discrimination or hate speech based on race, gender, religion, nationality, disability, sexual orientation, or gender identity.</li>
            <li>Using automated bots, scraping tools, or unauthorized third-party services.</li>
            <li>Soliciting money, financial information, personal details, or gifts from other users.</li>
            <li>Facilitating or promoting any illegal activity, including human trafficking, prostitution, or drug use.</li>
          </ul>
          <p>
            Violations may result in account termination, removal from app stores, and reporting to legal authorities. We cooperate fully with law enforcement in such matters.
          </p>
        </div>
      </section>

      {/* Updates to These Policies Section */}
      <section className="updates-section">
        <h2 className="section-title">Updates to These Policies</h2>

        <div className="content-block">
          <p>
            We reserve the right to update these policies at any time.
          </p>
          <ul className="list">
            <li>Significant changes will be communicated to users via the app and/or email.</li>
            <li>Continued use of Fervoir after changes constitutes acceptance of the new policies.</li>
          </ul>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <h2 className="section-title">Contact Us</h2>
        <div className="content-block">
          <p>For any questions, concerns, or feedback, please contact us at:</p>
          <p>
            Email: <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;